import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import styles from './styles';

const useStyles = makeStyles(styles);
const Loading = ({ classes }) => {
  const { loadingIndicator } = useStyles();
  return (
    <svg
      className={`${loadingIndicator} ${classes}`}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.2" cx="16.5" cy="16.5" r="15.5" stroke="white" strokeWidth="2" />
      <path d="M16 32C24.8366 32 32 25.0604 32 16.5C32 7.93959 24.8366 1 16 1" stroke="white" strokeWidth="2" />
    </svg>
  );
};

Loading.propTypes = {
  classes: PropTypes.string,
};

export default Loading;
